module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-44.89b8a191.svg";